import { CSSProperties, FC } from 'react';

import Lottie, { LottieOptions } from 'lottie-react';

import { ContainerProps } from '../Container';
import { TestMetadata } from '../types';
import defaultLoader from './animation/defaultLoader.json';

const defaultOptions: LottieOptions = {
  loop: true,
  autoplay: true,
  animationData: defaultLoader,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export interface LottiePlayerProps {
  /** Custom lottie options to overwrite */
  customOptions?: LottieOptions;
  /** Custom styles for the lottie */
  style?: CSSProperties;
  /** Test IDs for component sections */
  testMetadata?: TestMetadata;
  /** Container props overrides */
  containerProps?: Omit<ContainerProps, 'children'>;
}

const LottiePlayer: FC<LottiePlayerProps> = ({
  customOptions,
  style = {
    top: 'calc(50% - 79px)',
    left: 'calc(50% - 90px)',
    maxHeight: '158px',
    maxWidth: '180px',
    position: 'absolute',
  },
  testMetadata,
}) => {
  return (
    <Lottie
      {...defaultOptions}
      {...customOptions}
      style={style}
      {...testMetadata}
    />
  );
};

export default LottiePlayer;
